<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <el-dialog
    title="机构列表"
    :visible="show"
    width="40%"
    :before-close="closeWindow"
    append-to-body
  >
    <div class="cu-title1">
      <div class="cu-title2">
        <div>机构名称:</div>
        <el-input size="medium" v-model="form1.statName"></el-input>
      </div>
      <div class="cu-title3">
        <el-button type="primary" size="medium" @click="getDataList"
          >查询</el-button
        >
      </div>
    </div>
    <div style="margin: 20px 0">
      <el-table
        class="form-table"
        :data="tableData"
        border
        highlight-current-row
        @current-change="tableChange"
        style="width: 100%"
      >
        <el-table-column
          fixed
          align="center"
          type="index"
          label="序号"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="statName"
          label="站点名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="address"
          show-overflow-tooltip
          label="地址"
        >
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
      "
    >
      <el-button type="primary" @click="send">保存</el-button>
      <el-button @click="closeWindow">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import request from "@/utils/request.js"

export default {
  name: "serveStation",
  props: {
    firstType: {
      type: [String,Object],
      default: "",
    },
    showStation: {
      type: Boolean,
      default: false,
    },
    serviceStationData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form1: {},
      tableData: [],
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      totalCount: 0,
      // 选中的数据
      servestation: undefined,
    }
  },
  computed: {
    show() {
      return this.showStation
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.tableData = []
      let params = {
        ...this.form1,
        id: this.firstType.serviceStation,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        customerId: this.firstType.customer,
      }
      request({
        url: "/ypt/admin/serviceStation/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list || []
            this.totalCount = res.content.count || 0
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getDataList()
    },
    // 选择机构 保存选择的数据
    tableChange(data) {
      console.log(data)
      this.servestation = data
    },
    // 确定选择
    send() {
      if (!this.servestation) {
        this.$message.error("请选择一个机构")
        return
      }
      this.$emit("send", JSON.parse(JSON.stringify(this.servestation)))
      this.closeWindow()
    },
    // 关闭窗口
    closeWindow() {
      this.servestation = undefined
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.form1 = {}
      this.tableData = []
      this.$emit("update:showStation", false)
    },
    isFreeFormat(row, column) {
      if (row.isFree === "0") {
        return "否"
      } else if (row.isFree === "1") {
        return "是"
      }
    },
    typeFormat(row, column) {
      if (row.type === 7) {
        return "商业客户"
      } else if (row.type === 6) {
        return "民政客户"
      } else if (row.type === 4) {
        return "老干客户"
      } else if (row.type === 3) {
        return "残联客户"
      }
    },
  },
}
</script>
<style lang="less" scoped>
.cu-title1 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.cu-title1 > div {
  width: 50%;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
</style>
